import * as React from "react";
import C from "classnames";
export const CardTitle = (props) => {
    return (React.createElement("h3", { className: C("card-title", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=CardTitle.js.map